/**
 * Headless template loader.
 *
 * Uses Vite's `import.meta.glob` with `?raw` to eagerly import every file
 * from the headless-template directory at build time. The keys are relative
 * paths like `./headless-template/package.json`; we strip the prefix to
 * produce WebContainer-friendly paths like `package.json`.
 */

const PREFIX = './headless-template/';

const rawModules: Record<string, string> = import.meta.glob(
  './headless-template/**/*',
  { eager: true, query: '?raw', import: 'default' },
) as Record<string, string>;

let _cache: Record<string, string> | null = null;

/**
 * Returns `{ "package.json": "...", "src/App.tsx": "...", ... }` for every
 * file in the headless-template directory. Result is cached after first call.
 */
export function getHeadlessTemplateFiles(): Record<string, string> {
  if (_cache) return _cache;

  const files: Record<string, string> = {};
  for (const [key, content] of Object.entries(rawModules)) {
    const relativePath = key.startsWith(PREFIX) ? key.slice(PREFIX.length) : key;
    files[relativePath] = content;
  }
  _cache = files;
  return files;
}
